import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import TableKeyIconCustom from '../../components/CustomIcons/TableKeyIconCustom.jsx';
import MksKeyDetailsView from '../../components/MKS/MksKeyDetailsView.jsx';
import MksKeysHeader from '../../components/MKS/MksKeysHeader.jsx';
import MksKeysTableView from '../../components/MKS/MksKeysTableView.jsx';
import OperationalView from '../../components/OperationalView/OperationalView.jsx';
import * as MksActions from '../../redux/actions/mks.actions';
import * as UtilsActions from '../../redux/actions/utils.actions';

let filterTimeout;

@connect(state => ({ 
  mks: state.mks, 
  routing: state.router, 
  language: state.settings.language, 
  viewLoading: state.utils.viewLoading, 
  themeName: state.settings.items.theme.data.themeName 
}))
class MksKeys extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isOperationalMode: false,
      keyFunctionFilter: '',
      designationFilter: '',
      filteredKeys: [],
    };
  }

  async componentWillMount() {
    await this.onFetchKeys();
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(MksActions.setSelectedKey({}));
  }

  async onFetchKeys(page = 0) {
    const { dispatch } = this.props;
    dispatch(UtilsActions.setViewLoading(true));
    try {
      await dispatch(MksActions.fetchKeys(page));
    } catch (error) {
      console.error('Error fetching keys:', error);
    } finally {
      dispatch(UtilsActions.setViewLoading(false));
    }
  }

  onFetchKeysOnPage(page) {
    this.onFetchKeys(page);
  }

  async onSelectKey(key) {
    const { dispatch } = this.props;
    try {
      dispatch(UtilsActions.setSpinnerVisibile(true));
      
      // Fetch associated cylinders for this key
      const relationsData = await dispatch(MksActions.fetchKeyRelations(key.id));
      const cylinders = relationsData && relationsData.content ? _.map(relationsData.content, relation => relation.cylinder) : [];
      // Set selected key with relations data
      const keyWithRelations = {
        ...key,
        associatedCylinders: cylinders,
      };
      dispatch(MksActions.selectKey(keyWithRelations));
      this.setState({ isOperationalMode: true });
      dispatch(UtilsActions.setSpinnerVisibile(false));
    } catch (error) {
      console.error('Error fetching key relations:', error);
      dispatch(MksActions.selectKey(key));
      this.setState({ isOperationalMode: true });
      dispatch(UtilsActions.setSpinnerVisibile(false));
    }
  }

  onCloseOperationalSection() {
    const { dispatch } = this.props;
    this.setState({ isOperationalMode: false });
    dispatch(MksActions.setSelectedKey({}));
  }

  onRequestKeyDuplication(keyData) {
    const { dispatch } = this.props;
    dispatch(push(`/mksRequests?keyId=${keyData.id}`));
  }

  onKeyFunctionChange(value) {
    clearTimeout(filterTimeout);
    filterTimeout = setTimeout(() => {
      this.setState({ keyFunctionFilter: value }, () => {
        this.onApplyFilters();
      });
    }, 300);
  }

  onDesignationChange(value) {
    clearTimeout(filterTimeout);
    filterTimeout = setTimeout(() => {
      this.setState({ designationFilter: value }, () => {
        this.onApplyFilters();
      });
    }, 300);
  }

  onApplyFilters() {
    const { mks: { keys: { data: keysData } } } = this.props;
    const { keyFunctionFilter, designationFilter } = this.state;
    
    const allKeys = keysData && keysData.content ? keysData.content : [];
    
    let filtered = allKeys;
    
    if (keyFunctionFilter) {
      filtered = _.filter(filtered, key => 
        key.keyFunction && key.keyFunction.toLowerCase().includes(keyFunctionFilter.toLowerCase())
      );
    }
    
    if (designationFilter) {
      filtered = _.filter(filtered, key => 
        key.designation && key.designation.toLowerCase().includes(designationFilter.toLowerCase())
      );
    }
    
    this.setState({ filteredKeys: filtered });
  }

  onSearchReset() {
    this.setState({ 
      keyFunctionFilter: '', 
      designationFilter: '',
      filteredKeys: [] 
    });
  }

  getDisplayedKeys() {
    const { mks: { keys: { data: keysData } } } = this.props;
    const { filteredKeys, keyFunctionFilter, designationFilter } = this.state;
    
    const hasFilters = keyFunctionFilter || designationFilter;
    
    if (hasFilters) {
      return {
        content: filteredKeys,
        pagination: {
          totalElements: filteredKeys.length,
          number: 0,
          size: filteredKeys.length,
          totalPages: 1,
        }
      };
    }
    
    return keysData;
  }

  render() {
    const { mks: { keys: { selectedKey } }, themeName, viewLoading } = this.props;
    const { isOperationalMode } = this.state;
    
    const displayedKeysData = this.getDisplayedKeys();
    const pagination = displayedKeysData && displayedKeysData ? _.omit(displayedKeysData, 'content') : {};
    const numberOfKeys = pagination.totalElements || 0;

    return (
      <div>
        <MksKeysHeader
          themeName={themeName}
          onKeyFunctionChange={value => this.onKeyFunctionChange(value)}
          onDesignationChange={value => this.onDesignationChange(value)}
          onSearchReset={() => this.onSearchReset()}
          onRefresh={() => this.onFetchKeys()}
          totalKeys={numberOfKeys}
          entitiesNumberSection={
            <div style={{ marginRight: 20, marginTop: 13, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <TableKeyIconCustom style={{ width: 22 }} />
              <h4 style={{ marginTop: 5 }}>{numberOfKeys}</h4>
            </div>
          }
        />
        <MksKeysTableView
          keysData={displayedKeysData}
          onSelectKey={key => this.onSelectKey(key)}
          onRefreshKeys={() => this.onFetchKeys()}
          onFetchKeysOnPage={page => this.onFetchKeysOnPage(page)}
        />
        <OperationalView
          themeName={themeName}
          isVisible={isOperationalMode}
          onClose={() => this.onCloseOperationalSection()}
          title={<Entity entity="keyDetails" />}
        >
          <div style={{ padding: 5 }}>
            <MksKeyDetailsView
              keyData={selectedKey}
              onRequestKeyDuplication={keyData => this.onRequestKeyDuplication(keyData)}
            />
          </div>
        </OperationalView>
      </div>
    );
  }
} 

export default MksKeys;

